import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Flex, Icon, useMultiStyleConfig, } from '@chakra-ui/react';
import { BxsCheckCircle, BxsErrorCircle, BxsInfoCircle } from '../icons';
export const Infobox = ({ variant = 'info', children, icon: iconProp, size, ...flexProps }) => {
    const styles = useMultiStyleConfig('Infobox', { variant, size });
    const iconToRender = useMemo(() => {
        if (iconProp) {
            return _jsx(Box, { __css: styles.icon, children: iconProp });
        }
        if (variant === 'error') {
            return _jsx(Icon, { as: BxsErrorCircle, __css: styles.icon });
        }
        if (variant === 'success') {
            return _jsx(Icon, { as: BxsCheckCircle, __css: styles.icon });
        }
        return _jsx(Icon, { as: BxsInfoCircle, __css: styles.icon });
    }, [iconProp, styles.icon, variant]);
    return (_jsxs(Flex, { sx: styles.messagebox, ...flexProps, children: [iconToRender, children] }));
};
